import angular from 'angular';
import { URL_SIGN_UP } from 'common';

import SignUpComponent from './sign-up.cmpt';

export default angular
    .module('application.scene.identity.scene.sign-up', [])
    .component(SignUpComponent.selector, SignUpComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.sign-up', {
        url: URL_SIGN_UP,
        template: '<db-a-sign-up class="block-component"></db-a-sign-up>',
        data: {
            requires: {
                anonymous: 'authorized.calendar'
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/sign-up/index.js